import * as React from 'react';

import LearnerIncentiveModule from 'bundles/unified-description-page-common/components/modules/learner-incentive/LearnerIncentiveModule';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';
import type { EnterpriseSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseSpecializationPageQuery';

type Props = {
  pageData:
    | ConsumerCoursePageFieldsFragment
    | EnterpriseCoursePageFieldsFragment
    | ConsumerSpecializationPageFieldsFragment
    | EnterpriseSpecializationPageFieldsFragment;
};

const LearnerIncentiveModuleRenderer = ({ pageData }: Props) => {
  // Pick the first incentive. We don't support multiple learner incentives yet.
  const learnerIncentive =
    pageData.learnerIncentivePromotions && pageData.learnerIncentivePromotions.length > 0
      ? pageData.learnerIncentivePromotions[0]
      : undefined;

  if (!learnerIncentive) {
    return null;
  }

  return (
    <LearnerIncentiveModule
      title={learnerIncentive.title}
      text={learnerIncentive.text}
      // @ts-expect-error URL: string
      imageSrc={learnerIncentive.imageUrl}
    />
  );
};

export default LearnerIncentiveModuleRenderer;
